export default __webpack_public_path__ + "static/media/BarefeetLead-1.e843f222.webp";